import { render, staticRenderFns } from "./AdminSiuntimoAdministravimas.vue?vue&type=template&id=41f51b9f&scoped=true&"
import script from "./AdminSiuntimoAdministravimas.vue?vue&type=script&lang=js&"
export * from "./AdminSiuntimoAdministravimas.vue?vue&type=script&lang=js&"
import style0 from "./AdminSiuntimoAdministravimas.vue?vue&type=style&index=0&id=41f51b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f51b9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VFooter,VSpacer,VTextField,VToolbar})
